import { InputGroup } from '@blueprintjs/core';
import DataTableFilterLabel from 'Components/Generic/AdvancedDataTable/DataTableFilterLabel';
import PropTypes from 'prop-types';
import styles from 'Styles/styles.module.css';

const DataTableHeaderTextFieldFilter = ({
  fieldName = '',
  defaultValue = '',
  onFilterValueUpdate = () => {},
}) => {
  return (
    <div className={styles.filter_label_header_box}>
      <DataTableFilterLabel label={fieldName} />
      <InputGroup
        type='text'
        fill={true}
        onChange={onFilterValueUpdate}
        defaultValue={defaultValue}
      />
    </div>
  );
};

DataTableHeaderTextFieldFilter.propTypes = {
  fieldName: PropTypes.string,
  defaultValue: PropTypes.string,
  onFilterValueUpdate: PropTypes.func,
};

export default DataTableHeaderTextFieldFilter;
